document.addEventListener('DOMContentLoaded', () => {
  // capsule_main_page_banner_scroll_down_click
  // capsule_page_scroll_down_click
  window.dataLayer = window.dataLayer || [];
  const scrollDownClicks = document.querySelectorAll(
    '.home-slider__down-click'
  );
  if (scrollDownClicks.length) {
    scrollDownClicks.forEach(btn => {
      let eventName = btn.closest('.capsule-hero-slider')
        ? 'capsule_main_page_banner_scroll_down_click'
        : 'capsule_page_scroll_down_click';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        dataLayer.push({
          event: 'custom_event',
          event_name: `${eventName}`
        });
      });
    });
  }

  // capsule_page_not_your_style_click
  const capsuleStyleSection = document.querySelector('.section-capsule-style');
  if (capsuleStyleSection) {
    const capsuleStyleSectionLinks = capsuleStyleSection.querySelectorAll('a');
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const from = pathParts[pathParts.length - 1];
    capsuleStyleSectionLinks.forEach(link => {
      link.addEventListener('click', () => {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'capsule_page_not_your_style_click',
          parameter: JSON.stringify({
            from,
            to: `${link.href.split('/').pop()}`
          })
        });
      });
    });
  }

  // capsule_main_page_block_explore_more_click
  const styleMoreSection = document.querySelector('.capsules-blocks');
  if (styleMoreSection) {
    const styleMoreSectionLinks = styleMoreSection.querySelectorAll('a');
    styleMoreSectionLinks.forEach(link => {
      link.addEventListener('click', () => {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'capsule_main_page_block_explore_more_click',
          parameter: JSON.stringify({
            content_number: `${link.dataset.index}`,
            content_url: `${link.href.split('/').pop()}`
          })
        });
      });
    });
  }

  // capsule_page_product_click
  document.addEventListener('click', e => {
    const linkEl = e.target.closest(
      '.capsule-category .item a.card-information__wrapper-link'
    );

    if (!linkEl) return;

    const categoryEl = linkEl.closest('.capsule-category');
    if (!categoryEl) return;

    const type = categoryEl.dataset?.type ?? null;
    const href = linkEl.getAttribute('href') || '';
    const handle = href.split('/').pop() || '';

    dataLayer.push({
      event: 'custom_event',
      event_name: 'capsule_page_product_click',
      parameter: JSON.stringify({
        from: type,
        context_url: handle
      })
    });
  });

  // capsule_page_shop_the_look_click
  const capsuleBlockLinks = document.querySelectorAll('.capsule-looks a');
  if (capsuleBlockLinks) {
    capsuleBlockLinks.forEach(link => {
      link.addEventListener('click', () => {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'capsule_page_shop_the_look_click',
          parameter: JSON.stringify({
            content_number: `${link.dataset.index}`,
            content_url: `${link.href.split('/').pop()}`
          })
        });
      });
    });
  }
});
